import { useState } from "react";
import { X, ArrowLeft, ArrowRight } from "lucide-react";

const ConfirmRuleChangeModal = ({ open, onConfirm, onCancel }) => {

  const [accepted, setAccepted] = useState(false);

  if (!open) return null;

  return (

    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

      <div className="bg-white rounded-2xl shadow-xl w-[560px] p-8 relative">

        {/* CLOSE BUTTON */}
        <button
          onClick={onCancel}
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-600"
        >
          <X size={18} />
        </button>


        {/* TITLE */}
        <h2 className="text-xl font-semibold mb-6">
          Confirm Screening Changes
        </h2>


        {/* TEXT */}
        <div className="text-sm text-gray-600 space-y-4 mb-8">

          <p>
            You've modified the screening outcomes for this service.
          </p>

          {/* <p>
            You are responsible for how these outcomes are applied in your business.
          </p> */}

          <p>
            Please review your changes before continuing.
          </p>

        </div>


        {/* CHECKBOX */}
        <div className="flex items-center gap-3 mb-10">

          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="w-4 h-4"
          />

          <span className="text-sm text-gray-700">
            I have reviewed these changes and understand that my business is 
            responsible for configuring and applying these screening rules in 
            accordance with applicable laws, licensing requirements, and 
            professional standards.
          </span>

        </div>


        {/* BUTTONS */}
        <div className="flex justify-between items-center">

          <button
            onClick={onCancel}
            className="flex items-center gap-2 px-6 py-3 border rounded-full text-sm font-medium hover:bg-gray-50"
          >
            <ArrowLeft size={16} />
            Back to Edit
          </button>

          <button
            disabled={!accepted}
            onClick={onConfirm}
            className={`flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium
              ${accepted
                ? "bg-yellow-500 hover:bg-yellow-600 text-black"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
              }`}
          >
            Confirm & Continue
            <ArrowRight size={16} />
          </button>

        </div>

      </div>

    </div>

  );

};

export default ConfirmRuleChangeModal;